import moment from "moment";
import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Popup } from "semantic-ui-react";
import CnfirmDeletePublished from "../../On_going/Published/Published_Q_list/Cnfirm_Delete_Published";
import ScheduleActivityPopup from "./ScheduleActivityPopup";
import axios from "../../../../axios";
import NoResponse from "../../../Pre-read/Create_Assessment_PreRead/create_successfullPreRead/NoResponse";
const ScheduleAssessBoxActivity = ({ filter }) => {
  const [scheduleDelete, setScheduleDelete] = useState();
  const [noresponse, setNoresponse] = useState(false);
  let Teacher_id = localStorage.getItem("Teacher_id");
  let Teacher_Json = JSON.parse(Teacher_id);
  const [scheduledCard, setScheduledCard] = useState([]);
  const [isGettingData, setIsGettingData] = useState(true);
  useEffect(() => {
    const scheduledBox = async () => {
      let resposne = await axios.get(
        `/api/v1/homework/activity/filterByTeacherId/${Teacher_Json}/scheduled?` +
          `&${filter?.standard_id && `standardId=${filter?.standard_id}`}` +
          `&${filter?.section_id && `sectionId=${filter?.section_id}`}` +
          `&${filter?.searchvalue && `name=${filter?.searchvalue}`}` +
          `&${filter?.date && `date=${filter?.date}`}` +
          `&${filter?.time && `time=${filter?.time}`}` +
          `&${
            filter?.subjectId?.length !== 0 && `subjectId=${filter?.subjectId}`
          }`
      );
      if (resposne?.data.data.length === 0) {
        setNoresponse(true);
      }
      setIsGettingData(false);
      setScheduledCard(resposne.data.data);
    };
    scheduledBox();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);
  return scheduledCard && scheduledCard.length > 0 ? (
    <>
      {scheduledCard &&
        scheduledCard.length > 0 &&
        scheduledCard.map((schudleData) => (
          <div>
            <div className="d-flex  align-items-center published_activity_box">
              <NavLink
                to="/ScheduleQListActivity"
                className="link"
                state={{ scheduledActivity_id: schudleData?.id }}
              >
                <img
                  className="publishedImg"
                  src="/images/ActivityProps.png"
                  alt=""
                />
              </NavLink>
              <div className=" ms-2 subpublished_activity_box">
                <div className=" d-flex  justify-content-between selected_activity_class_section">
                  {/* <div> */}
                  <NavLink
                    to="/ScheduleQListActivity"
                    className="link"
                    state={{ scheduledActivity_id: schudleData?.id }}
                  >
                    <span className="selected_activity_class">
                      Class {schudleData?.standard_id?.name} &nbsp;
                      {schudleData?.section_id?.name} -&nbsp;
                    </span>
                    <span className="selected_activity_class">
                      {schudleData?.subject_id?.name}
                    </span>
                    {/* </div> */}
                  </NavLink>

                  <Popup
                    trigger={
                      <img
                        src="/images/menu-dots-vertical 1.svg"
                        className="published_activate_three_dot"
                        alt=""
                      />
                    }
                    content={
                      <div className="open_publish_activity_popupBox">
                        <ScheduleActivityPopup
                          setDelete={setScheduleDelete}
                          schudleActivity_id={schudleData?.id}
                        />
                      </div>
                    }
                    on="click"
                    hideOnScroll
                    position="bottom right"
                  />
                </div>
                <NavLink
                  to="/ScheduleQListActivity"
                  className="link"
                  state={{ scheduledActivity_id: schudleData?.id }}
                >
                  {/* <div> */}
                  <div className=" created_activity_name ">
                    {schudleData?.name}
                  </div>
                  {/* <div className="d-flex align-items-end justify-content-end  kk">
                    <span className="m-0 p-0 published_subOn">
                      Scheduled on
                    </span>
                  </div>
                  <div className="col-12 p-0  d-flex align-items-center justify-content-between date_box">
                    <div>
                      <span className=" published_subOn">Deadline </span>
                      <span className="published_submited_date">
                        {moment(schudleData?.deadline).calendar(null, {
                          sameDay: "[Today]",
                          nextDay: "[Tomorrow]",
                          nextWeek: "DD/MM/YYYY",
                          lastDay: "DD/MM/YYYY",
                          lastWeek: "DD/MM/YYYY",
                          sameElse: "DD/MM/YYYY",
                        })}
                      </span>
                    </div>
                    <span className="published_submited_date">
                      {moment(schudleData?.deadline).calendar(null, {
                        sameDay: "[Today]",
                        nextDay: "[Tomorrow]",
                        nextWeek: "DD/MM/YYYY",
                        lastDay: "DD/MM/YYYY",
                        lastWeek: "DD/MM/YYYY",
                        sameElse: "DD/MM/YYYY",
                      })}
                    </span> 
                  </div>
                    
                    */}
                  <div className="col-12 p-0  d-flex  justify-content-between ">
                    <div className="col-6 p-0 ">
                      <span className="published_subOn">Deadline : </span>
                      <span className="published_submited_date">
                        {moment(schudleData?.deadline).calendar(null, {
                          sameDay: "[Today]",
                          nextDay: "[Tomorrow]",
                          nextWeek: "DD/MM/YYYY",
                          lastDay: "DD/MM/YYYY",
                          lastWeek: "DD/MM/YYYY",
                          sameElse: "DD/MM/YYYY",
                        })}
                      </span>
                    </div>
                    <div className="col-5 p-0 d-flex align-items-end flex-column ">
                      <span className="published_subOn">Scheduled on </span>
                      <span className="published_submited_date">
                        {moment(schudleData?.schedule_date).calendar(null, {
                          sameDay: "[Today]",
                          nextDay: "[Tomorrow]",
                          nextWeek: "DD/MM/YYYY",
                          lastDay: "DD/MM/YYYY",
                          lastWeek: "DD/MM/YYYY",
                          sameElse: "DD/MM/YYYY",
                        })}
                      </span>
                    </div>
                  </div>

                  {/* <span className="published_submited_date">
                      &nbsp;
                      {moment(schudleData?.schedule_time).format("h:mm A")}
                    </span> */}
                  {/* </div> */}
                  {/* </div> */}
                </NavLink>
              </div>
            </div>
            {scheduleDelete && (
              <CnfirmDeletePublished
                setDelete={setScheduleDelete}
                activity_id={schudleData?.id}
                activitys={schudleData}
              />
            )}
          </div>
        ))}
    </>
  ) : // (
  //   <>
  //     <img
  //       className="publishAccessLoader"
  //       src="/gift/black loader.gif"
  //       alt=""
  //     />
  //     {noresponse && <NoResponse setNoresponse={setNoresponse} />}
  //   </>
  // );
  isGettingData ? (
    <img className="ongoing_loader" src="/gif/LoaderDot.gif" alt="" />
  ) : (
    <div className="d-flex justify-content-center align-items-center w-100">
      <span
        className="badge bg-light text-dark  rounded-pill px-4 py-3"
        style={{ fontSize: "1.2rem", letterSpacing: "0.5px" }}
      >
        📭 Activity Not Found
      </span>
    </div>
  );
};

export default ScheduleAssessBoxActivity;
